import React, { useMemo, useState } from "react";
import ReportFilterBar from "../../components/ReportFilterBar";
import ReportListings from "../../components/ReportListings";
import { reportListingTypes } from "../../components/reportListingTypes";
import StatsCard from "../../components/StatsCard";
import {
  defaultReportSections,
  reportSectionIds,
} from "../../components/StatsCard.data";

const TesteComponents = () => {
  const [searchValue, setSearchValue] = useState("");
  const [orderValue, setOrderValue] = useState("alfabetica");
  const [statusEntrega, setStatusEntrega] = useState("dentro-prazo");
  const [statusPedido, setStatusPedido] = useState("separacao");
  const [dataCriacao, setDataCriacao] = useState("2026-02-03");

  const orderOptions = useMemo(
    () => [
      { value: "alfabetica", label: "Ordem alfabética" },
      { value: "mais-antigos", label: "Pedidos mais antigos" },
      { value: "mais-recentes", label: "Pedidos mais recentes" },
    ],
    [],
  );

  const filterFields = useMemo(
    () => [
      {
        id: "status-entrega",
        label: "Status da entrega",
        value: statusEntrega,
        onChange: setStatusEntrega,
        options: [
          { value: "dentro-prazo", label: "Dentro do prazo" },
          { value: "atrasado", label: "Atrasado" },
        ],
      },
      {
        id: "status-pedido",
        label: "Status do pedido",
        value: statusPedido,
        onChange: setStatusPedido,
        options: [
          { value: "separacao", label: "Em separação" },
          { value: "faturado", label: "Faturado" },
          { value: "cancelado", label: "Cancelado" },
        ],
      },
      {
        id: "data-criacao",
        label: "Data de criação do pedido",
        type: "date",
        value: dataCriacao,
        onChange: setDataCriacao,
      },
    ],
    [dataCriacao, statusEntrega, statusPedido],
  );

  const clearFilters = () => {
    setSearchValue("");
    setOrderValue("alfabetica");
    setStatusEntrega("dentro-prazo");
    setStatusPedido("separacao");
    setDataCriacao("2026-02-03");
  };

  return (
    <div className="space-y-4">
      <ReportFilterBar
        searchValue={searchValue}
        onSearchValueChange={setSearchValue}
        onSearchSubmit={setSearchValue}
        orderValue={orderValue}
        onOrderChange={setOrderValue}
        orderOptions={orderOptions}
        showClearButton={false}
        orderPlacement="top"
      />

      <ReportFilterBar
        searchValue={searchValue}
        onSearchValueChange={setSearchValue}
        onSearchSubmit={setSearchValue}
        filterFields={filterFields}
        onClearFilters={clearFilters}
        orderValue={orderValue}
        onOrderChange={setOrderValue}
        orderOptions={orderOptions}
        orderPlacement="bottom"
      />

      <ReportFilterBar
        searchValue={searchValue}
        onSearchValueChange={setSearchValue}
        onSearchSubmit={setSearchValue}
        showOrder={false}
        onClearFilters={clearFilters}
      />

      <StatsCard
        sections={defaultReportSections}
        sectionId={reportSectionIds.posicaoCarga}
      />

      <ReportListings type={reportListingTypes.posicaoCarga} />
      <ReportListings type={reportListingTypes.autosservicos} />
      <ReportListings type={reportListingTypes.creditoClientes} />
    </div>
  );
};

export default TesteComponents;